export const ACCOUNT_EDIT_USERS_TAB = 1;

export const accessGroupTabs = {
  general: 'general',
  users: 'users',
  networkProtection: 'network-protection',
  applicationProtection: 'application-protection',
  dnsHosting: 'dns-hosting',
};

export const resourceTabs = {
  monitoringObjects: 'monitoring-objects',
  protectedProfiles: 'protected-profiles',
  ipAddressGroups: 'ip-address-groups',
  dnsZones: 'dns-zones',
  acls: 'acls',
};

export const getUsersAndGroupsPath = (accountId, search = '') =>
  `/edit-account/${ACCOUNT_EDIT_USERS_TAB}/${accountId}${search}`;

export const getEditUserPath = (accountId, userId) =>
  `/edit-account/${ACCOUNT_EDIT_USERS_TAB}/${accountId}/edit-user/${userId}`;

export const getAccessGroupPath = (accountId, groupId, accessTab = accessGroupTabs.general) =>
  `/edit-account/${ACCOUNT_EDIT_USERS_TAB}/${accountId}/access-groups/${groupId}/${accessTab}`;
